import { Button, Flex, Stack, Text } from '@mantine/core'
import { modals } from '@mantine/modals'

import { Icons } from 'src/common/components'

import { useMembershipMutations } from '../hook/useMembershipMutations.hook'

interface MembershipModalProps {
  membershipId: string
}

const GenerateApiModalContent = ({ membershipId }: MembershipModalProps) => {
  const { generateApiKey, isLoadingGenerateApi } = useMembershipMutations()

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault()
        generateApiKey(membershipId)
      }}
    >
      <Stack align="center" justify="center" gap="md">
        <Icons.Warning width="60" height="60" color="blue" />
        <Text size={'16px'} fw={700} c="blue">
          Confirm Generating new API Key
        </Text>
        <Text size={'14px'} fw={400} style={{ whiteSpace: 'pre-wrap' }}>
          This action cannot be undone. The existing API key will be deleted (if
          exist).
        </Text>
      </Stack>
      <Flex justify="space-between" align="flex-start" mt="lg">
        <Button onClick={() => modals.closeAll()} variant="outline">
          Cancel
        </Button>
        <Button loading={isLoadingGenerateApi} type="submit" variant="filled">
          Save
        </Button>
      </Flex>
    </form>
  )
}

export const openGenerateApiModal = (membershipId: string) => {
  return modals.open({
    centered: true,
    color: 'red',
    size: 'md',
    withCloseButton: true,
    children: <GenerateApiModalContent membershipId={membershipId} />,
  })
}
